import React, { useEffect, useState} from "react";
import styled from 'styled-components';


import ronin_chain from '../../styles/assets/chain/ronin.png';
import matic_chain from '../../styles/assets/chain/matic.png';
import eth_chain from '../../styles/assets/chain/eth.png';

import {chainMap} from '../../services/chainServices/chainService';
import { networkToChainId } from "../../constants/EIP1193";

const TokenAmount = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #FFFFFF;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
`;

const ChainName = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #7A7F9E;
`;

const TokenAmountPrice = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #7A7F9E;
    margin-top: 0px;
`;


const ActivityListItemComponent = (props:any) => {
  const getTokenImageUrl = (chain: string, contractAddress: string) => {
      if (chain === 'ronin') {
          // Special handling for specific Ronin tokens
          switch(contractAddress.toLowerCase()) {
              case '0x777baeb8bdad0e95ea94e3a4bcc6cc2938763725':
                  return 'https://cdn-m.namasteapis.com/crypto/wallet/token/137-0xf0075b06b4229c20b7c22b7e63d90723b3551861.png';
              case '0x1795f58d28263dc948a4edc7967e77a3a1f27893':
                  return 'https://cdn-m.namasteapis.com/crypto/btx/season-reward-badges/assets/2/1.png';
              default:
                  return `https://cdn-m.namasteapis.com/crypto/wallet/token/${networkToChainId.get(chain.toLowerCase())}-${contractAddress.toLowerCase()}.png`;
          }
      }
      return `https://cdn-m.namasteapis.com/crypto/wallet/token/${networkToChainId.get(chain.toLowerCase())}-${contractAddress.toLowerCase()}.png`;
  }

  // Logging for Ronin tokens
  if (props.item.chain === 'ronin') {
      // console.log('Ronin Token:', {
      //     imageUrl: getTokenImageUrl(props.item.chain, props.item.rawContract.address),
      //     contractAddress: props.item.rawContract.address
      // });
  }

  return (
      <div style={{display: 'flex', width: '100%', justifyContent: 'flex-start', alignContent: 'center', alignItems: 'center',}}>
        <div style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignContent: 'center',
            borderBottom: '0.5px solid #1C1F33',
            padding: 12,
            paddingLeft: 0,
        }}>
          <div style={{display: 'flex'}}>
            {true && <div style={{position: 'relative', marginRight: 12}}>
              <img 
                  style={{width: 36, height: 36, borderRadius: '100%'}}
                  src={getTokenImageUrl(props.item.chain, props.item.rawContract.address)}
                  alt='l'
                  onError={(e) => {
                      e.currentTarget.src = "https://cdn-m.namasteapis.com/crypto/wallet/token/unkown-token.png"
                  }}
              /> 
              {props.item.chain === 'ronin' && <img src={ronin_chain} alt='ronin chain icon' style={{width: 18, position: 'absolute', right: -4, bottom: 0}} />}
              {props.item.chain === 'matic' && <img src={matic_chain} alt='matic chain icon' style={{width: 18, position: 'absolute', right: -4, bottom: 0}} />}
              {props.item.chain === 'mainnet' && <img src={eth_chain} alt='eth chain icon' style={{width: 18, position: 'absolute', right: -4, bottom: 0}} />}
            </div>
            }
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
            }}>
              <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignContent: 'center',
              }}>
                <TokenAmount>{props.item.asset.toUpperCase()}</TokenAmount>
              </div>
              <ChainName>{chainMap[props.item.chain]}</ChainName>
            </div>
          </div>                        
          <div style={{display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', alignItems: 'flex-end'}}>
            <TokenAmount>{props.item.type === 'TO' ? '+ ' : '- '}{parseFloat(Number(props.item.value).toFixed(6))} {props.item.asset.toUpperCase()}
            </TokenAmount>
            <TokenAmountPrice>
              {props.item.type === 'TO' ? 'Received' : 'Sent'}
            </TokenAmountPrice>
          </div>
        </div>
      </div>
  )
}


export default ActivityListItemComponent;
